import styled from 'styled-components'

export const LayoutRoot = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.card.background};
`

export const TopHeader = styled.header`
  min-height: 125px;
  background-color: ${({ theme }) => theme.colors.surface.info};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 6px;
`

export const HeaderTopRow = styled.div`
  width: min(980px, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const GreetingRow = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
`

export const GreetingText = styled.span`
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.25);
  font-family: ${({ theme }) => theme.typography.fontPlusJakartaSans};
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
`

export const SignOutText = styled.span`
  color: #ffffff;
  font-family: ${({ theme }) => theme.typography.fontNunito};
  font-size: 14px;
  text-shadow: none;
  margin-left: 11px;
  font-weight: 700;
  cursor: pointer;
`

export const ThemeSwitchButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 999px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  font-family: ${({ theme }) => theme.typography.fontNunito};
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition:
    background-color 150ms ease,
    transform 120ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }

  &:active {
    transform: translateY(1px);
  }
`

export const ContentArea = styled.main`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CarouselContainer = styled.div`
  width: min(90vw, 908px);
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const ContentFrame = styled.div`
  /* width: min(908px, 100%); */
  width: min(90vw, 908px);

  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const NoAssignmentsContainer = styled.div`
  width: min(848px, 100%);
  height: 78px;
  border-radius: 8px;
  margin-top: 16px;
  background: ${({ theme }) => theme.colors.card.surface};
`
export const NoAssignmentsHeading = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  padding-left: 18px;
  padding-top: 12px;
  font-family: ${({ theme }) => theme.typography.fontPlusJakartaSans};
  font-size: 16px;
  margin: 0;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`
export const NoAssignmentsText = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.typography.fontPlusJakartaSans};
  font-size: 16px;
  padding-left: 18px;
  padding-top: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const DashboardContainer = styled.div`
  width: 100%;
  display: flex;
  max-width: 908px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Section = styled.section`
  width: min(908px, 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
`

export const MainHeading = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const SectionHeading = styled.h3`
  margin: 0;
  font-size: 20px;
  margin-left: 50px;
  font-family: ${({ theme }) => theme.typography.fontPlusJakartaSans};
  font-weight: 700;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ActivityFeedHeader = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 0 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CarouselShell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 11px;
`

export const CarouselButton = styled.button`
  width: 20px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 120ms ease;

  &:hover:not(:disabled) {
    opacity: 1;
  }

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`

export const CarouselButtonIcon = styled.img<{ $isRight?: boolean }>`
  width: 20px;
  height: 28px;
  object-fit: contain;
  display: block;
  transform: ${({ $isRight }) => ($isRight ? 'scaleX(-1)' : 'none')};
`

export const CarouselViewport = styled.div<{
  $showLeftFade: boolean
  $showRightFade: boolean
  $isDragging: boolean
  $isDraggable: boolean
}>`
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  overflow: hidden;
  user-select: none;
  cursor: ${({ $isDraggable, $isDragging }) => {
    if (!$isDraggable) {
      return 'default'
    }

    return $isDragging ? 'grabbing' : 'grab'
  }};

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 42px;
    pointer-events: none;
    z-index: 2;
    transition: opacity 180ms ease;
  }

  &::before {
    left: 0;
    opacity: ${({ $showLeftFade }) => ($showLeftFade ? 1 : 0)};
    background: ${({ theme }) =>
      `linear-gradient(to right, ${theme.colors.card.background} 0%, transparent 100%)`};
  }

  &::after {
    right: 0;
    opacity: ${({ $showRightFade }) => ($showRightFade ? 1 : 0)};
    background: ${({ theme }) =>
      `linear-gradient(to left, ${theme.colors.card.background} 0%, transparent 100%)`};
  }
`

export const CarouselTrack = styled.div<{
  $currentIndex: number
  $dragOffset: number
  $isDragging: boolean
  $stepPx: number
}>`
  display: flex;
  gap: 12px;
  transform: translateX(
    ${({ $currentIndex, $dragOffset, $stepPx }) =>
      `${-$currentIndex * $stepPx + $dragOffset}px`}
  );
  transition: ${({ $isDragging }) =>
    $isDragging ? 'none' : 'transform 250ms ease'};
`

export const CarouselSlide = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
`
